export const RELATED_COMPANY_ACCOUNTS = [
  { id_key: 341, name: 'Cuenta Corriente Empresa Relacionada 1', classification: '1-1-6-9 Cta Cte Empresa Relacionada 1' },
  { id_key: 342, name: 'Cuenta Corriente Empresa Relacionada 2', classification: '1-1-6-10 Cta Cte Empresa Relacionada 2' },
  { id_key: 343, name: 'Cuenta Corriente Empresa Relacionada 3', classification: '1-1-6-11 Cta Cte Empresa Relacionada 3' }
]
